import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/components/DashboardLayout';
import MainLayout from 'src/components/MainLayout';
import Account from 'src/pages/Account';
import CustomerList from 'src/pages/CustomerList';
import Dashboard from 'src/pages/Dashboard';
import Login from 'src/pages/Login';
import NotFound from 'src/pages/NotFound';
import ProductList from 'src/pages/ProductList';
import Register from 'src/pages/Register';
import Settings from 'src/pages/Settings';
import AboutTheDisease from './pages/AboutTheDisease';
import Logout from './pages/Logout';
import RunningSubmit from './pages/RunningSubmit';
import StravaCallback from 'src/pages/StravaCallback';
import Events from 'src/pages/Events';

const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'account', element: <Account /> },
      { path: 'running-detail', element: <RunningSubmit /> },
      { path: 'customers', element: <CustomerList /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'products', element: <ProductList /> },
      { path: 'settings', element: <Settings /> },
      { path: 'aboutTheDisease', element: <AboutTheDisease /> },
      { path: 'events', element: <Events /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login', element: <Login /> },
      { path: 'logout', element: <Logout /> },
      { path: 'register', element: <Register /> },
      { path: 'strava-callback', element: <StravaCallback /> },
      { path: '404', element: <NotFound /> },
      { path: '/', element: <Navigate to="/app/events" /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
